import { MdCheck } from 'react-icons/md';
import { Step, StepCircle, StepConnector, StepLabel, StepsRow } from './styles';

export default function RoundedStepper({ steps, activeStep }) {
  function getStatus(index, activeStep) {
    if (activeStep === index) return 'active';
    if (activeStep > index) return 'completed';
    return '';
  }

  return (
    <StepsRow>
      {steps.map((step, index) => {
        const status = getStatus(index, activeStep);
        return (
          <Step key={step}>
            <StepCircle className={status}>
              {status === 'completed' ? <MdCheck size={18} /> : index + 1}
            </StepCircle>
            <StepLabel className={status}>{step}</StepLabel>
            {index < steps.length - 1 && <StepConnector className={status} />}
          </Step>
        );
      })}
    </StepsRow>
  );
}
